<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  // @ts-ignore
  import { Button } from '$lib/components/ui/button';
  import Icon from '$shared/icons/Icon.svelte';
  import MoveMenu from './MoveMenu.svelte';
  import { toCompactDuration } from '$lib/utils';

  export let title: string | null = '';
  export let description: string | null = '';
  export let durationSeconds: number | null = null;
  export let questionCount = 0;
  export let responseCount = 0;
  export let editable = false;

  export let typeLabel = 'Question set';
  export let untitledText = 'Untitled question set';
  export let questionText = 'question';
  export let questionsText = 'questions';
  export let responseText = 'response';
  export let responsesText = 'responses';
  export let editLabel = 'Edit question set';
  export let moveLabel = 'Move question set';
  export let duplicateLabel = 'Duplicate question set';
  export let deleteLabel = 'Delete question set';
  export let isFirst = false;
  export let isLast = false;
  export let moveTopLabel = 'Move to top';
  export let moveUpLabel = 'Move up';
  export let moveDownLabel = 'Move down';
  export let moveBottomLabel = 'Move to bottom';

  // Sends "open" when the owner clicks the picture, the title or the pencil. The move menu's
  // "opening" and "move" pass straight through to the set.
  const dispatch = createEventDispatcher();

  $: duration = toCompactDuration(durationSeconds) || '0m';
</script>

<!-- The closed set, laid out like a lesson card. Move, duplicate and delete don't do anything yet. -->
<div class="relative flex flex-col gap-4 md:space-y-0 md:space-x-4 md:flex-row mt-4 w-full md:flex-shrink-0 md:mt-0 items-start">
  <div class="absolute z-10 right-[-1rem] top-0 h-full flex items-start p-2">
    {#if editable}
      <div class="flex items-center">
        <Button variant="ghost" size="icon" class="w-8 h-8 p-0" on:click={() => dispatch('open')}>
          <span class="sr-only">{editLabel}</span>
          <Icon icon="SquarePen" size="small" />
        </Button>
        <MoveMenu label={moveLabel} {isFirst} {isLast} {moveTopLabel} {moveUpLabel} {moveDownLabel} {moveBottomLabel} on:opening on:move />
        <Button variant="ghost" size="icon" class="w-8 h-8 p-0">
          <span class="sr-only">{duplicateLabel}</span>
          <Icon icon="Copy" size="small" />
        </Button>
        <Button variant="ghost" size="icon" class="w-8 h-8 p-0">
          <span class="sr-only">{deleteLabel}</span>
          <Icon icon="Trash2" size="small" />
        </Button>
      </div>
    {/if}
  </div>
  <div class="flex gap-4 w-full md:w-3/4">
    <div class="w-full md:w-1/2 max-w-[30rem]">
      <div class="aspect-w-16 aspect-h-9">
        <button
          type="button"
          class="grid place-content-center border-[24px] border-neutral-200 bg-gradient-to-b from-neutral-200/20 to-neutral-500/20 text-neutral-400 enabled:hover:outline enabled:hover:outline-1 enabled:hover:outline-black"
          disabled={!editable}
          on:click={() => dispatch('open')}
        >
          <Icon icon="LayoutList" iconClass="w-24 h-24" />
        </button>
      </div>
    </div>
    <div class="w-full md:w-1/2 content-card__headline-stack">
      <div class="content-card__headline-stack__type">{typeLabel}</div>
      <button type="button" class="text-left font-semibold text-base text-black" disabled={!editable} on:click={() => dispatch('open')}>
        {title || untitledText}
      </button>
      {#if description}
        <p class="content-card__description mt-2">{description}</p>
      {/if}
      <div class="content-card__duration">
        <Icon icon="Clock" size="small" /><span>{duration}</span>
      </div>
      <div class="content-card__duration">
        <Icon icon="LayoutList" size="small" /><span>{questionCount} {questionCount === 1 ? questionText : questionsText}</span>
      </div>
      {#if responseCount > 0}
        <div class="content-card__duration">
          <Icon icon="Users" size="small" /><span>{responseCount} {responseCount === 1 ? responseText : responsesText}</span>
        </div>
      {/if}
    </div>
  </div>
</div>
